/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */

import CommunityPluginFactory from '@spoketree-plugin-ui/community';
import ExchangePluginFactory from '@spoketree-plugin-ui/exchange';
import CapabilityPluginFactory from '@spoketree-plugin-ui/capability';
import SupplierPortalPluginFactory from '@spoketree-plugin-ui/supplierportal';
import MessageReprocessorPluginFactory from '@spoketree-plugin-ui/messagereprocessor';

const container = {
  plugins: {
    exchange: {
      path: "exchange",                     // TODO: change path to alias
      factory: ExchangePluginFactory,
      options: {
        api: [/*
          "spoketree-community-feature",
          "spoketree-exchange-console"
        */]
      }
    },
    capability: {
      path: "capability",                     // TODO: change path to alias
      factory: CapabilityPluginFactory,
      options: {
        api: [/*
          "spoketree-community-feature",
          "spoketree-exchange-console"
        */]
      }
    },
    community: {
      path: "community",                     // TODO: change path to alias
      factory: CommunityPluginFactory,
      options: {
        api: [/*
          "spoketree-community-feature",
          "spoketree-exchange-console"
        */]
      }
    },
    supplierportal: {
      path: "supplierportal",                    // TODO: change path to alias
      factory: SupplierPortalPluginFactory,
      options: {
        api: [/*
          "spoketree-community-feature",
          "spoketree-exchange-console"
        */]
      }
    },
    messagereprocessor: {
      path: "messagereprocessor",                    // TODO: change path to alias
      factory: MessageReprocessorPluginFactory,
      options: {
        api: [/*
          "spoketree-community-feature",
          "spoketree-exchange-console"
        */]
      }
    }
  }
};

export default container;
